import { Box } from "@mui/material";
import { AvatarWithPopup } from "Components/Layout/UserHeader/AvatarWithPopup";
import { NotificationWithPopover } from "Components/Layout/UserHeader/Notifications/NotificationWithPopover";
import { LoyaltyPointsLink } from "Components/Loyalty/LoyaltyPointsLink";

/**
 * Chat page header. The actions sit on the LEFT, right after the avatar — the global floating
 * support button occupies the top-right corner on every page, so anything anchored there (the
 * notification bell used to be) ends up underneath it.
 */
export const ChatHeaderBar = () => (
  <Box
    bgcolor="primary.main"
    py={2.5}
    px={3}
    display="flex"
    alignItems="center"
    gap={1.5}
    flexShrink={0}
  >
    <AvatarWithPopup />
    <NotificationWithPopover colorVariant="dark" />
    <LoyaltyPointsLink />
  </Box>
);
